// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t6rU","type":"styles_type__P6jJN","choices":"styles_choices__2UqlE"};